import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { ItemRelatedLinksProps } from './type'

import { PaletteFilledIcon } from '@/components/icons'
import { ContentPasteFilledIcon } from '@/components/icons/ContentPasteFilled'
import { FormatListBulletFilledIcon } from '@/components/icons/FormatListBulletFilled'
import { Icon, LinkText } from '@/components/ui'
import { ROUTE, LINEUP_TITLE } from '@/const'

export const ItemRelatedLinks = ({ item, disabled }: ItemRelatedLinksProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={clsx(
        'lg:tw-w-pcHalf',
        'tw-flex tw-items-center',
        'tw-gap-8',
        'tw-py-2'
      )}
    >
      <div>
        <LinkText href={ROUTE.itemDetail(item.itemCode)} disabled={disabled}>
          <span>
            <Icon icon={ContentPasteFilledIcon} size={'lg'} />
          </span>
          <span className={clsx('tw-ml-1', 'tw-text-sm')}>
            {t('item.card.detail')}
          </span>
        </LinkText>
      </div>

      {item.lineupCode && (
        <LinkText href={ROUTE.lineups(item.lineupCode)} disabled={disabled}>
          <span>
            <Icon icon={FormatListBulletFilledIcon} size={'lg'} />
          </span>
          <span className={clsx('tw-ml-1', 'tw-text-sm')}>{LINEUP_TITLE}</span>
        </LinkText>
      )}

      {item.hairColorAttribute && (
        <LinkText
          href={ROUTE.colorCharts(item.hairColorAttribute.groupId)}
          disabled={disabled}
        >
          <span>
            <Icon icon={PaletteFilledIcon} size={'lg'} />
          </span>
          <span className={clsx('tw-ml-1', 'tw-text-sm')}>
            {t('item.card.color.all')}
          </span>
        </LinkText>
      )}
    </div>
  )
}
